import { isEqual } from 'lodash-es';
import {
  createElement,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';

import { useMergedRef } from '@/hook';

import { useBaseInput } from '../VBaseInput';
import { useVBaseSelectContext } from '../VBaseSelect';
import { VFlex } from '../VFlex';
import { KeyboardArrowDown, KeyboardArrowUp } from '../asset';
import { joinCn } from '../util';
import twStyle from './style';

const VSelectDisplayLabel = ({
  ref,
}: React.RefAttributes<HTMLInputElement>) => {
  const {
    disabled,
    displayedLabel,
    itemList,
    itemListVisible,
    multiple,
    placeholder,
    value,
    $displayValue,
  } = useVBaseSelectContext();
  const { size, status, setStatus } = useBaseInput();
  const shortedDisplayedLabel = useMemo(() => {
    if (multiple && value != null && value.length > 1) {
      const firstLabel =
        itemList.find(i => isEqual(i.value, value[0]))?.label ?? value[0];

      return `${firstLabel} +${value.length - 1}`;
    }

    return displayedLabel;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedLabel, multiple]);
  const [isValueExceedingWidth, setIsValueExceedingWidth] = useState(false);
  const mergedRefs = useMergedRef(ref, $displayValue);
  const style = twStyle({ size });

  useEffect(() => {
    setStatus(prev => ({ ...prev, disabled }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useLayoutEffect(() => {
    let isValueExceedingWidth = false;

    if (
      multiple &&
      value != null &&
      value.length > 1 &&
      $displayValue.current
    ) {
      const dummyTag = document.createElement('span');

      dummyTag.textContent = displayedLabel;
      dummyTag.className = joinCn('absolute opacity-0');

      document.body.append(dummyTag);

      if (dummyTag.offsetWidth > $displayValue.current.offsetWidth - 32) {
        isValueExceedingWidth = true;
      }

      dummyTag.remove();
    }

    setIsValueExceedingWidth(isValueExceedingWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedLabel, multiple]);

  return (
    <VFlex gap={0.25} ref={mergedRefs} className="w-full" items="center">
      <input
        value={
          isValueExceedingWidth
            ? (shortedDisplayedLabel ?? '')
            : (displayedLabel ?? '')
        }
        className={style.displayValue}
        readOnly
        placeholder={placeholder}
        onFocus={() => setStatus({ ...status, focused: true })}
        onBlur={() => setStatus({ ...status, focused: false })}
        onChange={() => {}}
      />
      {createElement(itemListVisible ? KeyboardArrowUp : KeyboardArrowDown, {
        className: style.arrowIcon,
      })}
    </VFlex>
  );
};

export default VSelectDisplayLabel;
